var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavingHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2502 31.3105C13.2262 31.3105 13.2001 31.3062 13.1739 31.2996C10.5497 30.4997 7.70765 27.6315 7.09085 25.162C7.05595 25.0226 7.14095 24.8831 7.27825 24.8482C7.41775 24.8133 7.55725 24.8983 7.59215 25.0356C8.161 27.3132 10.8941 30.0616 13.3243 30.8049C13.4616 30.8463 13.5379 30.9901 13.4965 31.1274C13.4638 31.2386 13.3613 31.3105 13.2502 31.3105Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5015 34.5646C14.4819 34.5646 14.4623 34.5624 14.4426 34.558C12.2718 34.0524 9.74795 32.4308 7.52045 30.1074C5.4368 27.9366 4.08767 25.6263 4.00049 24.0788C3.99177 23.9371 4.10074 23.8129 4.24459 23.8064C4.38626 23.7977 4.5105 23.9066 4.51704 24.0505C4.5955 25.4585 5.92065 27.6947 7.89315 29.75C10.053 32.0036 12.4832 33.5707 14.5603 34.0546C14.6998 34.0873 14.787 34.2268 14.7543 34.3662C14.726 34.4839 14.6192 34.5646 14.5015 34.5646Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6281 11.917C25.5126 11.917 25.4079 11.8408 25.3774 11.7252C25.0134 10.3434 23.3592 8.36 21.8531 7.97205C21.7158 7.93715 21.6308 7.7955 21.6679 7.656C21.7049 7.5165 21.8444 7.4337 21.9839 7.47075C23.6796 7.90885 25.4711 10.047 25.8787 11.5945C25.9158 11.7318 25.833 11.8734 25.6935 11.9105C25.6717 11.9149 25.6499 11.917 25.6281 11.917Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8907 12.3768C28.7752 12.3768 28.6705 12.2984 28.64 12.1828C27.6701 8.36425 24.0434 5.38483 21.9728 5.01431C21.8311 4.98816 21.7396 4.85521 21.7636 4.71354C21.7897 4.57186 21.9227 4.48032 22.0643 4.5043C24.3202 4.90969 28.1039 7.98065 29.1413 12.0542C29.1762 12.1937 29.0934 12.3332 28.9539 12.3681C28.9321 12.3746 28.9125 12.3768 28.8907 12.3768Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4503 19.1618C22.8666 19.6217 23.2415 20.2255 23.0823 20.3846C22.9232 20.5437 22.435 20.2559 22.0623 19.8811C21.6896 19.5083 20.7982 23.4752 20.711 23.6756C20.6456 23.826 19.6082 25.016 19.0655 26.1472C18.8846 26.5243 18.9107 27.6621 18.8431 27.7296C18.5707 28.0021 18.2242 27.9737 17.4766 27.3133C16.729 26.6529 16.341 30.587 17.2325 31.2082C18.756 32.2718 21.803 36.4979 25.8286 36.4979C30.4862 36.4979 34.7996 31.6397 34.7996 28.0739C34.7996 24.5082 33.7534 23.1569 33.8231 20.1688C33.8798 17.6384 35.7215 16.4309 35.7215 15.1667C35.7215 14.1031 34.1413 13.8438 33.6226 13.8438C32.7028 13.8438 30.3446 15.0229 30.3446 18.1266C30.3446 19.334 30.0002 20.4259 28.7644 20.4259C27.5286 20.4259 26.149 18.7303 25.3142 17.4073",
    fill: "url(#paint0_linear_2665_2045)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7195 15.1668C35.7195 14.5892 35.2509 14.2492 34.7409 14.0574C35.3533 16.0865 32.2475 16.1737 32.2475 23.0872C32.2475 30.0007 28.2219 32.0124 26.5545 32.359C24.8872 32.7034 21.9492 32.8036 19.713 30.0596C19.0264 29.2161 18.0958 28.3007 17.0605 27.4354C16.6224 28.1656 16.5287 30.7178 17.2327 31.2082C18.7562 32.2718 21.8031 36.4979 25.8288 36.4979C30.4864 36.4979 34.7997 31.6397 34.7997 28.074C34.7997 24.5083 33.7536 23.157 33.8233 20.1688C33.88 17.6384 35.7195 16.4309 35.7195 15.1668Z",
    fill: "url(#paint1_linear_2665_2045)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4767 27.3134C16.7291 26.653 14.9615 24.7698 13.8107 23.8479C12.6599 22.9281 11.6551 22.939 10.9642 23.9547C10.2733 24.9704 12.2872 26.7532 12.7471 27.2131C13.4511 27.9171 16.3411 30.587 17.2326 31.2104",
    fill: "url(#paint2_linear_2665_2045)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7106 23.6755C20.6234 23.8761 20.0371 24.0155 18.8711 22.747C17.9797 21.7771 15.5931 18.9895 14.1851 17.7253C12.7771 16.4612 11.683 15.9425 10.7632 16.6051C9.84344 17.2677 10.3665 18.6451 11.3953 19.7959C12.6681 21.2191 14.1328 22.6708 15.5342 24.0657C16.6305 25.1554 19.113 27.4592 18.8406 27.7316",
    fill: "url(#paint3_linear_2665_2045)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5369 24.0635C16.5722 25.0923 18.8389 27.1999 18.8629 27.6641C19.1898 27.1541 18.5926 25.6372 17.9605 25.1054C14.3076 22.03 10.779 17.0716 10.33 17.2198C10.1382 17.9413 10.6242 18.9307 11.3958 19.796C12.6686 21.2171 14.1333 22.6708 15.5369 24.0635Z",
    fill: "url(#paint4_linear_2665_2045)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3122 17.4095C24.4775 16.0865 21.0556 11.8321 20.223 10.6246C19.3882 9.41711 18.2679 9.41711 17.492 9.96421C16.7161 10.5113 16.4851 11.6032 18.2331 13.9244C19.3359 15.3891 20.2513 16.736 22.4527 19.164L25.0114 18.9853L25.3122 17.4095Z",
    fill: "url(#paint5_linear_2665_2045)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0627 19.8811C21.69 19.5084 18.3837 15.5896 17.6361 14.7483C16.2347 13.1747 14.4583 9.80292 12.3398 11.3046C11.2261 12.0936 11.8298 13.2379 12.1458 13.6978C12.4619 14.1577 16.5725 18.9025 16.9757 19.3036C17.3789 19.7068 20.7986 23.473 20.7136 23.6735",
    fill: "url(#paint6_linear_2665_2045)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4505 19.1617C22.8515 19.6041 23.2111 20.1773 23.0978 20.3626C24.4317 19.2903 21.6114 16.1387 20.0138 14.2468C18.778 12.7822 18.4401 10.9187 17.5552 9.92041C17.5334 9.93351 17.5138 9.94876 17.492 9.96181C16.7161 10.5089 16.4851 11.6009 18.2331 13.9221C19.3337 15.3867 20.2513 16.7359 22.4505 19.1617Z",
    fill: "url(#paint7_linear_2665_2045)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9734 19.3057C17.3766 19.7089 20.7963 23.4751 20.7113 23.6756C21.7683 22.2524 17.6708 18.0699 15.6874 15.9557C13.9678 14.1227 13.6735 12.5186 11.9953 11.6184C11.3719 12.3726 11.8667 13.2967 12.1435 13.6999C12.4595 14.1598 16.5723 18.9046 16.9734 19.3057Z",
    fill: "url(#paint8_linear_2665_2045)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6343 23.7608C20.5144 23.8349 20.2681 23.8414 19.8867 23.6213C20.1701 23.8502 20.4316 23.9373 20.6343 23.7608Z",
    fill: "url(#paint9_linear_2665_2045)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8644 14.2753C34.7427 14.1184 34.8975 14.2187 34.7405 14.0574C34.3133 13.8983 33.8556 13.8438 33.6203 13.8438C32.7005 13.8438 30.3422 15.0229 30.3422 18.1266C30.3422 19.334 29.9979 20.4259 28.7599 20.4259C28.2717 20.4259 27.7638 20.1623 27.2734 19.7612C29.4443 22.1652 31.1465 19.9007 31.4058 18.3489C31.6652 16.7971 31.2881 14.7373 33.8644 14.2753Z",
    fill: "url(#paint10_radial_2665_2045)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2258 10.1973C16.6896 10.8054 16.7071 11.8952 18.2306 13.9221C19.3334 15.3868 20.2488 16.7337 22.4502 19.1617C22.8664 19.6216 23.2413 20.2254 23.0822 20.3845C23.4506 17.8693 19.8696 15.3955 18.7057 13.4993C17.7838 11.9954 17.6007 11.1083 17.2258 10.1973Z",
    fill: "url(#paint11_linear_2665_2045)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9729 19.3057C17.3761 19.7089 20.7958 23.4751 20.7108 23.6756C21.4649 23.1373 20.9505 22.2982 19.7845 21.1321C17.3935 18.7412 14.0654 15.5285 12.7271 12.8826C12.6007 12.6319 12.3653 12.4467 12.0885 12.4118C11.3671 12.3181 11.9033 13.349 12.1452 13.6999C12.459 14.1598 16.5718 18.9046 16.9729 19.3057Z",
    fill: "url(#paint12_linear_2665_2045)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3961 19.796C12.669 21.2192 14.1336 22.6708 15.5351 24.0657C16.6314 25.1555 19.1139 27.4592 18.8414 27.7317C20.3802 26.437 13.2335 21.7576 10.3282 17.2219C10.1385 17.939 10.6246 18.9307 11.3961 19.796Z",
    fill: "url(#paint13_linear_2665_2045)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5271 27.989C18.6731 27.9323 18.7494 27.8648 18.7733 27.7907C18.5096 27.9934 18.1631 27.9214 17.4765 27.3133C16.7289 26.6529 14.9613 24.7698 13.8105 23.8479C13.3049 23.4447 12.8276 23.2202 12.3916 23.1809C13.015 23.5711 12.7251 23.7106 14.1113 24.7742C14.8567 25.3452 17.5768 28.3617 18.5271 27.989Z",
    fill: "url(#paint14_linear_2665_2045)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7158 21.0886C17.7249 22.3179 19.6952 24.347 20.5801 23.7869C20.336 23.8697 19.7802 23.7346 18.8735 22.7473C17.9821 21.7774 15.5955 18.9897 14.1875 17.7256C13.0476 16.7012 12.1126 16.1672 11.3105 16.3525C13.6448 17.1197 15.759 19.9269 16.7158 21.0886Z",
    fill: "url(#paint15_linear_2665_2045)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.808 15.7987C19.4187 17.5511 21.8097 21.0275 23.0215 20.4194C22.8231 20.4804 22.3959 20.2167 22.0625 19.881C21.6898 19.5083 18.3834 15.5895 17.6358 14.7482C16.6638 13.6584 15.5151 11.7056 14.1943 11.1084C15.526 12.1589 16.5025 14.3799 17.808 15.7987Z",
    fill: "url(#paint16_linear_2665_2045)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2741 19.7633C27.2763 19.7633 27.2763 19.7633 27.2741 19.7633C26.5221 19.1486 25.816 18.2093 25.3103 17.4094C24.4777 16.0864 21.0559 11.8319 20.2233 10.6245C19.9683 10.2561 19.6893 10.0011 19.3994 9.83984C19.7874 10.3978 20.0075 11.1933 20.8858 12.1785C22.2938 13.7586 24.1355 16.6051 24.7676 17.5837C25.3975 18.558 26.4175 20.6198 27.2741 19.7633Z",
    fill: "url(#paint17_linear_2665_2045)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.886 33.7953C31.3629 32.5224 30.5979 31.7465 29.4929 32.4745C26.4786 34.4601 23.011 33.7888 18.6628 30.2753C14.7854 27.139 12.7802 24.8984 10.8927 24.0876C10.4394 25.1185 12.3051 26.7728 12.7453 27.2131C13.4493 27.9171 16.3394 30.587 17.2308 31.2104C18.7543 32.274 21.8013 36.5001 25.8269 36.5001C28.0784 36.4979 30.2448 35.3667 31.886 33.7953Z",
    fill: "url(#paint18_linear_2665_2045)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.821 20.1687C33.8777 17.6383 35.7194 16.4308 35.7194 15.1667C35.7194 14.794 35.5254 14.5216 35.2508 14.3232C35.5864 15.3084 34.7866 16.1824 33.5922 17.6688C32.2975 19.2795 32.012 21.7794 32.9013 24.2815C33.7927 26.7836 32.6702 30.2339 30.859 31.3258C29.0478 32.4178 26.6416 37.2193 19.7521 31.7944C19.7499 31.7922 19.7499 31.7922 19.7477 31.79C19.3271 31.3999 18.9108 31.0534 18.4901 30.7918C15.5805 28.9893 13.9218 27.3678 12.6686 26.0056C12.4223 25.7375 11.7597 24.7109 10.9707 25.0487C11.3652 25.9423 12.4267 26.8948 12.7449 27.213C13.4489 27.917 16.3389 30.5869 17.2304 31.2103C17.3459 31.2909 17.4723 31.3912 17.6052 31.5067C17.6401 31.5372 17.675 31.5677 17.7099 31.5982C17.7186 31.607 17.7295 31.6157 17.7382 31.6222C17.76 31.6418 17.784 31.6636 17.8058 31.6833C17.8101 31.6876 17.8167 31.692 17.821 31.6985C18.7255 32.5202 19.97 33.8802 21.4957 34.9417C21.4957 34.9417 21.4979 34.9417 21.4979 34.9438C21.6309 35.0376 21.7682 35.1291 21.9055 35.2163C21.9077 35.2185 21.9098 35.2185 21.912 35.2206C22.0493 35.3078 22.1888 35.3928 22.3283 35.4735C22.3305 35.4735 22.3305 35.4756 22.3327 35.4756C23.3876 36.0816 24.558 36.5 25.8221 36.5C30.4798 36.5 34.7931 31.6418 34.7931 28.0761C34.7931 24.5104 33.7535 23.1591 33.821 20.1687Z",
    fill: "url(#paint19_radial_2665_2045)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2665_2045",
    x1: 32.5352,
    y1: 37.4202,
    x2: 28.6972,
    y2: 28.4282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2665_2045",
    x1: 33.2993,
    y1: 31.1663,
    x2: 25.2493,
    y2: 21.5638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2665_2045",
    x1: 11.7823,
    y1: 24.7733,
    x2: 16.526,
    y2: 28.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2665_2045",
    x1: 10.0545,
    y1: 15.5275,
    x2: 18.3776,
    y2: 24.2388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2665_2045",
    x1: 16.4444,
    y1: 20.7005,
    x2: 13.6931,
    y2: 23.2924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2665_2045",
    x1: 19.045,
    y1: 11.4177,
    x2: 23.875,
    y2: 19.0077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2665_2045",
    x1: 14.0594,
    y1: 12.6786,
    x2: 20.6144,
    y2: 21.5336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2665_2045",
    x1: 21.855,
    y1: 13.7469,
    x2: 17.715,
    y2: 17.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2665_2045",
    x1: 18.0469,
    y1: 16.4098,
    x2: 12.3544,
    y2: 20.5714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2665_2045",
    x1: 22.2868,
    y1: 22.2105,
    x2: 16.5942,
    y2: 26.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2665_2045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7565 15.4541) scale(6.83405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2665_2045",
    x1: 22.6123,
    y1: 13.013,
    x2: 19.0761,
    y2: 16.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2665_2045",
    x1: 19.9043,
    y1: 14.7895,
    x2: 15.2468,
    y2: 18.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2665_2045",
    x1: 18.331,
    y1: 19.3295,
    x2: 12.581,
    y2: 24.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2665_2045",
    x1: 12.0563,
    y1: 22.8383,
    x2: 18.7407,
    y2: 28.2721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2665_2045",
    x1: 13.3357,
    y1: 16.1031,
    x2: 18.5538,
    y2: 24.0381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2665_2045",
    x1: 17.4233,
    y1: 16.6698,
    x2: 18.8896,
    y2: 15.5486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2665_2045",
    x1: 24.6592,
    y1: 21.0996,
    x2: 22.7041,
    y2: 11.7846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2665_2045",
    x1: 20.1963,
    y1: 30.0398,
    x2: 17.2638,
    y2: 32.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2665_2045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1382 21.1319) rotate(48.1401) scale(19.8089 17.9802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893686,
    stopColor: "#BB6400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHand);
export default __webpack_public_path__ + "static/media/wavingHand.df39fd6fe6e926cb0e78306cf68a8b5f.svg";
export { ForwardRef as ReactComponent };